'use strict';

var elementCtrl = ["graphDataFactory", function(graphDataFactory) {
    var _this = this;
    this.config = false;

    this.isLoading = () => graphDataFactory.isBuilderElementLoading(_this.element);

    this.toggleConfig = () => {
        if (_this.isLoading()) return;
        _this.config = !_this.config;
    };

    this.cloneSubElement = (id) => {
        this.cloneElement({
            id: id
        });
    };

    // console.log('graphElementDirective 2 this.integrations', this.integrations)
    // console.log('graphElementDirective 2 this.departmentforms', this.departmentforms)
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            removeElement: '&',
            cloneElement: '&',
            graph: '=',
            forms: '=',
            integrations: '=',
            departmentforms: '=',
        },
        replace: true,
        controller: elementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/graphElementDirective.html'
    };
};
